/**
 * A global namespace for most scroll event listeners.
 */
const passiveHandler: Partial<AddEventListenerOptions> = { passive: true };

export default passiveHandler;
